import { render, staticRenderFns } from "./PassengerId.vue?vue&type=template&id=cecbd414&"
import script from "./PassengerId.vue?vue&type=script&lang=js&"
export * from "./PassengerId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports